<template>
    <div class="modal com_modal2" id="dispensingUnitModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
                    <h3 class="com_fs18 com_strong1 com_center1 com_mgb5 com_lh1">
                        調剤包装単位コードを読み取ることはできません。<br>
                        販売包装単位コードかJANコードの商品を読みとってください。
                    </h3>
                    <div class="modal-footer">
                        <button type="button" class="btn com_app_btn2" data-bs-dismiss="modal">戻る</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>